import styled from 'styled-components';

const Menu = styled.div`
  overflow-y: auto;
  margin-bottom: 16px;
`;
export default Menu;
